import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/auth/signin/page.tsx");
